import { SEASONAL_LEAD_DAYS, daysUntil, nthSunday } from './seasonalDates'

export type OccasionOption = { label: string, value: string, display?: string }

export const EVERGREEN_OCCASIONS = [
  { label: 'Birthday', value: 'birthday' },
  { label: 'Anniversary', value: 'anniversary' },
  { label: 'Thank you', value: 'thank you' },
  { label: 'Housewarming', value: 'housewarming' },
  { label: 'Congratulations', value: 'congratulations' },
] as const satisfies OccasionOption[]

// The dated occasions the corpus can serve, each resolving to its canonical
// occasion GiftTag. Hanukkah is deliberately absent — it follows the lunar
// calendar, so a fixed-date table can't place it; add it when these dates move
// server-side.
type Holiday = { label: string, value: string, date: (year: number) => Date }

const HOLIDAYS = [
  { label: 'Christmas', value: 'christmas', date: (year: number) => new Date(year, 11, 25) },
  { label: "Valentine's Day", value: "valentine's day", date: (year: number) => new Date(year, 1, 14) },
  { label: "Mother's Day", value: "mother's day", date: (year: number) => nthSunday(year, 4, 2) },
  { label: "Father's Day", value: "father's day", date: (year: number) => nthSunday(year, 5, 3) },
  { label: 'New Year', value: 'new year', date: (year: number) => new Date(year, 0, 1) },
] as const satisfies Holiday[]

// An upcoming holiday leads the list, nearest first — holidays (Mother's Day,
// Christmas) drive far more gifting than a generic birthday, so the season's
// occasion is the first thing offered. The evergreen occasions (birthday first)
// follow. Away from every window it's just the evergreen order.
export function seasonalOccasionOptions (today: Date): OccasionOption[] {
  const upcoming = HOLIDAYS
    .map(holiday => ({ holiday, days: daysUntil(holiday.date, today) }))
    .filter(({ days }) => days <= SEASONAL_LEAD_DAYS)
    .sort((a, b) => a.days - b.days)
    .map(({ holiday }) => ({ label: holiday.label, value: holiday.value, display: holiday.label }))

  return [...upcoming, ...EVERGREEN_OCCASIONS]
}
